// (c) TwistedMinds, Gerry Uytdenhouwen - 30 oktober 2026

const RESET_PREFIX = '#besteller-reset=';

/**
 * Reads the password reset data from a location hash.
 * Only the exact format `#besteller-reset=<token>&email=<urlencoded email>` is accepted;
 * any other hash (the shop's own anchors) returns null.
 *
 * @param {string} hash
 * @returns {{token: string, email: string}|null}
 */
export const parseResetFragment = (hash) => {
    if (typeof hash !== 'string' || !hash.startsWith(RESET_PREFIX)) {
        return null;
    }
    const params = new URLSearchParams(hash.slice(1));
    const token = params.get('besteller-reset');
    const email = params.get('email');
    if (!token || !email) {
        return null;
    }
    return {token, email};
};

/**
 * Returns the given address without its fragment, keeping origin, path and query intact.
 *
 * @param {string} href
 * @returns {string}
 */
export const stripFragment = (href) => {
    const url = new URL(href);
    url.hash = '';
    return url.toString();
};
